import { render, staticRenderFns } from "./chargeLink.vue?vue&type=template&id=4964e9e6&scoped=true&"
import script from "./chargeLink.vue?vue&type=script&lang=js&"
export * from "./chargeLink.vue?vue&type=script&lang=js&"
import style0 from "./chargeLink.vue?vue&type=style&index=0&id=4964e9e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964e9e6",
  null
  
)

export default component.exports